import { Controller } from "@hotwired/stimulus"
import { scroll, animate } from "motion"

// Scroll-linked parallax powered by Motion (motion.dev).
//
//   <div data-controller="parallax">
//     <div data-parallax-target="layer" data-speed="30">…background…</div>
//   </div>
//
// `data-speed` is how far (px) the layer drifts across the section's scroll
// range. Vertical only, driven by scroll position alone — nothing here reacts
// to the pointer.
//
// The layer is purely decorative, so if anything here is unavailable the
// background simply stays put — nothing is hidden or broken.
export default class extends Controller {
    static targets = ["layer"]

    connect() {
        this.cleanups = []

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

        this.layerTargets.forEach((layer) => {
            const distance = Number(layer.dataset.speed || 40)

            const cleanup = scroll(
                animate(layer, { y: [-distance, distance] }, { ease: "linear" }),
                {
                    target: this.element,
                    // from the section entering the viewport to it leaving again
                    offset: ["start end", "end start"],
                },
            )

            this.cleanups.push(cleanup)
        })
    }

    disconnect() {
        this.cleanups.forEach((stop) => stop?.())
        this.cleanups = []
    }
}
